import { JRAPIClient } from "shared/api/http-clients/JRAPIClient"
import { SchakoAPIClient } from "shared/api/http-clients/SchakoAPIClient"

export async function request(path: RequestInfo | URL, init?: RequestInit) {
  if (typeof path === "string") {
    if (path.startsWith(import.meta.env.VITE_API_BASE)) {
      return SchakoAPIClient.request(path, init)
    }
    if (path.startsWith(import.meta.env.VITE_JR_API_BASE)) {
      return JRAPIClient.request(path, init)
    }
  }
  return fetch(path, init)
}
